/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PileTurnerScanContainerResponse } from '../../models/pile-turner-scan-container-response';
import { PileTurnerScanEntry } from '../../models/pile-turner-scan-entry';

export interface PileTurnerScanContainer$Params {
  pileTurnerWorkCenterId: number;
      body: PileTurnerScanEntry
}

export function pileTurnerScanContainer(http: HttpClient, rootUrl: string, params: PileTurnerScanContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<PileTurnerScanContainerResponse>> {
  const rb = new RequestBuilder(rootUrl, pileTurnerScanContainer.PATH, 'post');
  if (params) {
    rb.path('pileTurnerWorkCenterId', params.pileTurnerWorkCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PileTurnerScanContainerResponse>;
    })
  );
}

pileTurnerScanContainer.PATH = '/api/v1/PileTurner/{pileTurnerWorkCenterId}/ScanContainer';
